import React, { ReactElement } from "react";
import { StepProps } from "../TradeModal";
import LoadingBlock from "components/Loading/LoadingBlock";

export default function LoadingTradeModal(props: StepProps): ReactElement {
  props.setTitle("Loading Trading Experience");

  return (
    <div>
      <LoadingBlock />
    </div>
  );
}
